<template>
  <div class="knockout">
    <!--<h3>Accomodation</h3>-->
    <v-layout row wrap v-if="paymentTrue !== undefined || paymentTrue !== null || paymentTrue.length > 0" >
      <v-flex xs12 md4 v-if="accomodation.pricing_status === 'true'" v-for="accomodation in paymentTrue" :key="accomodation.public_id">
        <v-container fluid>
          <v-card flat hover>
            <router-link :to="{name: 'PFacility', params: {facility_id: accomodation.public_id}}">
              <img class="img-responsive" :src="accomodation.thumbnail" style="width:100%">
            </router-link>
            <v-container fluid>
              <router-link style="text-decoration: none" :to="{name: 'PFacility', params: {facility_id: accomodation.public_id}}"><h4 style="text-color: black" class="earth-color">{{(accomodation.name).toUpperCase()}}</h4></router-link>
              <span v-if="accomodation.accomodation_type_id === 'Stables'">
                <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px">Price {{$localCurrency}} {{$roundOff(convert1(accomodation.price[0].currency_type, accomodation.price[0].mandatory_price).amount)}}</h4>
              </span>
              <span v-else>
                <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px">Price Packs</h4>
                <v-chip color="yellow" small v-for="(price, key) in developPricePacks(accomodation)" :key="key"><span>From  <b>{{price.lower_limit}}</b> to <b>{{price.upper_limit}}</b> : <b>{{$localCurrency}} {{$roundOff(convert1(price.currency, price.price).amount)}}</b></span></v-chip>
              </span>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="paymentTrue === undefined || paymentTrue === null || paymentTrue.length === 0">
      <v-flex lg4 md12 xs12 sm12 v-for="n in 3" :key="n">
        <v-container fluid>
          <v-card>
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'Accomodations',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_active_accommodation')
  },
  methods: {
    openFacility: function (publicId) {
      this.$router.push({
        name: 'Facility',
        params: {
          facility_id: publicId
        }
      })
    },
    getAccomodationUrl: function (image) {
      return '@/assets/images/accomodation/accomodation' + image + '.jpg'
    },
    facilityImage: function (image) {
      return 'http://178.79.164.219:8000/var/www/html/opc_services/' + image
    }
  },
  computed: {
    paymentTrue: function () {
      var activeInventory = []
      this.allAccommodations.map(function (data) {
        if (data.pricing_status === 'true' && data.thumbnail !== null) {
          activeInventory.push(data)
        }
      })
      return activeInventory
    }
  }
}
</script>

<style>
</style>
